import React from 'react';
import { Link } from 'react-router-dom';
import { social } from '../data/social';
import Logo from '../assets/img/waras-logo-light.png';
import { COMPANY } from '../data/content';

const Footer = () => {
  const year = new Date().getFullYear();

  const columns = [
    {
      title: 'Delivery',
      links: [
        { label: 'Servicios', to: { pathname: '/', hash: '#servicios' } },
        { label: 'Descargar app', href: COMPANY.playStore },
        { label: 'Cobertura', to: { pathname: '/', hash: '#cobertura' } },
      ],
    },
    {
      title: 'Negocios',
      links: [
        { label: 'Afiliar negocio', to: '/afiliate' },
        { label: 'Waras Restaurants', to: '/restaurantes' },
        { label: 'Probar POS 14 días', href: COMPANY.restaurantUrl },
      ],
    },
    {
      title: 'Comunidad',
      links: [
        { label: 'Ser motorizado', to: '/quiero-ser-driver' },
        { label: 'Contacto', to: '/contacto' },
        { label: 'Política de privacidad', to: '/politicas' },
        { label: 'Eliminación de cuenta', to: '/eliminacion-cuenta' },
      ],
    },
  ];

  return (
    <footer className='bg-ink text-white'>
      <div className='container mx-auto px-4 py-14 lg:py-16'>
        <div className='grid md:grid-cols-2 lg:grid-cols-5 gap-10'>
          <div className='lg:col-span-2'>
            <Link to='/' className='inline-block mb-4'>
              <img src={Logo} alt='Waras Delivery' className='w-44 h-auto object-contain' />
            </Link>
            <p className='text-white/70 text-sm max-w-sm mb-6'>
              Logística y software para Huaraz: delivery, panel para negocios y gestión de restaurantes.
            </p>
            <div className='flex gap-3'>
              {social.map((item) =>
                item.href ? (
                  <a
                    key={item.icon}
                    href={item.href}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='w-10 h-10 flex items-center justify-center rounded-full border border-white/15 text-white/80 hover:text-white hover:border-white/40'
                    aria-label={item.icon}
                  >
                    {item.icon === 'youtube' ? (
                      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                        <path d='M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z' />
                        <polygon points='9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02' />
                      </svg>
                    ) : (
                      <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                        <rect x='2' y='2' width='20' height='20' rx='5' />
                        <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' />
                        <line x1='17.5' y1='6.5' x2='17.51' y2='6.5' />
                      </svg>
                    )}
                  </a>
                ) : null
              )}
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className='text-white text-sm font-semibold tracking-wide uppercase mb-4'>{col.title}</h3>
              <ul className='space-y-2'>
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.href ? (
                      <a
                        href={link.href}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-sm text-white/70 hover:text-white'
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link to={link.to} className='text-sm text-white/70 hover:text-white'>
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className='mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between text-sm text-white/50'>
          <p>&copy; {year} Waras Developers. Todos los derechos reservados.</p>
          <p>
            {COMPANY.city} · {COMPANY.hours}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
